<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入厂家名"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;this.loadFactoryList()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="factoryTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="厂家名称">
      </el-table-column>
      <el-table-column prop="contactName"
                       label="联系人">
      </el-table-column>
      <el-table-column prop="contactPhone"
                       label="联系电话">
      </el-table-column>
      <el-table-column prop="address"
                       label="地址">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadFactoryList()}">
      </es-pagination>
    </div>
    <!--编辑厂家-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['factoryForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑厂家
      </span>
      <el-form :model="factoryInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="factoryForm">
        <el-form-item prop="name"
                      label="厂家名称">
          <el-input v-model="factoryInfo.name"
                    placeholder="请输入厂家名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="contactName"
                      label="联系人">
          <el-input v-model="factoryInfo.contactName"
                    placeholder="请输入联系人"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="contactPhone"
                      label="联系电话">
          <el-input v-model="factoryInfo.contactPhone"
                    placeholder="请输入联系电话"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="address"
                      label="地址">
          <el-input v-model="factoryInfo.address"
                    placeholder="请输入地址"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitFactory()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'factory',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      factoryInfo: {},//工厂信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入厂家名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ],
        contactName: [
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { max: 11, message: '不能超过11个字符', trigger: 'blur' }
        ],
        address: [
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadFactoryList()
    },
    //从后台查询工厂列表
    loadFactoryList () {
      this.loading = true
      this.$ajax.get('/base/factory/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加工厂
    add_init () {
      this.editVisible = true
      this.factoryInfo = {}
    },
    //初始化系统专业
    edit_init (row) {
      this.editVisible = true
      this.factoryInfo = JSON.parse(JSON.stringify(row))
    },
    //保存系统专业
    submitFactory () {
      this.$refs["factoryForm"].validate(valid => {
        if (valid) {
          let url = "/base/factory/add";
          if (this.factoryInfo.id != null) {
            url = "/base/factory/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.factoryInfo).then(msg => {
            this.saving = false
            this.loadFactoryList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除系统专业
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["factoryTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/factory/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadFactoryList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
